import { useState, useCallback } from "react";
import { getGroupUserKpiReport } from "../service/ReportingService";
import { showErrorMessage } from "../components/shared/pagination/messages";

const useGroupUserKpiReport = () => {
  const [data, setData] = useState([]);
  const [groupName, setGroupName] = useState("");

  const fetchGroupUserKpiReport = useCallback(async (groupId, currentPage, pageSize, searchText) => {
    try {
      const response = await getGroupUserKpiReport(groupId, currentPage - 1, pageSize, searchText);
      if (response.status === "SUCCESS") {
        const records = response.data?.content || [];
        setData(records);
        setGroupName(response.data?.metaDetails?.name || "");
        return response;
      } else {
        showErrorMessage(response?.message || "Something went wrong.");
      }
    } catch (error) {
      showErrorMessage(error?.message || "Something went wrong.");
    }
  }, []);

  return { data, groupName, fetchGroupUserKpiReport };
};

export default useGroupUserKpiReport;